module.exports = __webpack_public_path__ + "media/img/qback-36654ccf.png";